<style lang="scss" scoped>
.youtube-input-form {
  background-color: #eee;
  padding: 15px 15px 50px;
  margin: 0 0 10px;

  h2 {
    font-size: 14px;
    margin: 0 0 10px;
  }
}
</style>

<template>
  <div class="youtube-input">
    <div class="youtube-input-form" v-if="isEditing">
      <h2>Youtube</h2>
      <div class="form-group">
        <input
          class="form-control"
          type="text"
          v-model="url"
          placeholder="youtubeのURLを入力してください"
        />
      </div>
      <div class="form-group">
        <a class="btn-green" @click="onEndEdit()">追加</a>
        <a class="btn-green" @click="onDeleteInput()">削除</a>
      </div>
    </div>
    <div class="youtube-input-preview input-preview" v-else>
      <div class="youtube-wrap" v-if="embedURL.length">
        <iframe
          width="420"
          height="315"
          :src="embedURL"
          allowFullScreen="true"
        ></iframe>
      </div>
      <footer-menu
        :onBeginEdit="onBeginEdit"
        :onDeleteInput="onDeleteInput"
        :onPullUp="onPullUp"
        :onPullDown="onPullDown"
        :index="index"
      />
    </div>
  </div>
</template>

<script>
import footerMenu from './input-footer-menu.vue';
export default {
  props: {
    value: {},
    index: Number,
    id: String,
  },
  methods: {
    youtube_parser(url) {
      const regExp =
        /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#\&\?]*).*/;
      let match = url.match(regExp);
      return match && match[7].length == 11 ? match[7] : false;
    },
    onBeginEdit() {
      this.isEditing = true;
    },
    onEndEdit() {
      if (!this.valid) {
        alert('URLを入力してください。');
        return false;
      }
      this.isEditing = false;
    },
    onDeleteInput() {
      bus.$emit('delete-input', this.index);
    },
    onPullUp() {
      bus.$emit('pull-up-item', this.index);
    },
    onPullDown() {
      bus.$emit('pull-down-item', this.index);
    },
  },
  mounted() {
    this.url = this.value.url;
  },
  components: {
    'footer-menu': footerMenu,
  },
  computed: {
    valid() {
      return this.url.length;
    },
    embedURL() {
      if (!this.url.length) return '';

      const id = this.youtube_parser(this.url);
      return `https://www.youtube.com/embed/${id}`;
    },
    bodyJSON() {
      return {
        value: {
          url: this.url,
        },
        action: 'youtube',
      };
    },
  },
  data() {
    return {
      isEditing: false,
      url: '',
    };
  },
};
</script>
